import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import React from "react";
import { useMediaQuery } from "../hooks/mediaQuery";
import { NavigationDrawerDesktop } from "./NavigationDrawerDesktop";
import { NavigationDrawerMobile } from "./NavigationDrawerMobile";
import { NavigationToggleButton } from "./NavigationToggleButton";

export const NavigationDrawer: React.FC<{
  corePath: string;
  logo?: IGatsbySvg;
  navigation: Queries.MainNavigationFragment;
}> = (props) => {
  const isLarge = useMediaQuery("(min-width: 1024px)", false);
  if (!isLarge) {
    return (
      <nav
        data-component="Navigation Drawer"
        className="wbond-full page-grid fixed left-0 top-0 z-50 lg:hidden"
      >
        <NavigationToggleButton className="z-50 col-start-5 mb-30px ml-auto mt-30px text-right md:col-start-9" />
        <NavigationDrawerMobile {...props} />
      </nav>
    );
  }
  return (
    <nav className="wbond-full page-grid pointer-events-none fixed top-1/4 z-50">
      <NavigationToggleButton
        displayWhen="NAV_CLOSED"
        className="pointer-events-auto col-span-1 col-start-2 mt-30px text-left"
      />
      <NavigationDrawerDesktop {...props} />
    </nav>
  );
};
